import { Link } from '@remix-run/react'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* TODO: Add Meta */}
			{/* <Helmet
      title="United Wealth Advisors Group"
      meta={[
        {
          name: "description",
          content:
            "The Steele Agency is proud to be a part of this Group of Advisors.",
        },
        {
          name: "keywords",
          content:
            "UWAG, Financial Advisor, Wealth Planning, Financial Planning",
        },

      ]}
    /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/about-us/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				About Us
			</Link>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">The UWAG Advantage</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We created United Wealth Advisors Group, LLC (UWAG) so our clients could
				benefit from the talent, ideas, and practices of every member of our
				seven offices throughout the country. While we are not the largest
				wealth planning firm with hundreds of advisors, we do have depth and
				scale. We aligned with a group of local affiliates who are concerned
				about their clients, community, and industry.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				United Wealth Advisors Group, LLC, and its partner affiliates, provides
				comprehensive wealth management services that help bring clarity,
				structure, and stability to life. Working in direct partnerships with
				our affiliates, UWAG focuses on understanding clients' needs and
				offering actionable advice tailored to their individual circumstances.
				Our group's promise is to help clients maximize wealth so that they may
				fulfill their dreams, honor their commitments, and ensure their legacy.
				Our goal is to become our clients' most trusted advisor--ready and able
				to meet whatever challenges arise.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				As an affiliated United Wealth Advisors Group office, we strive to
				secure the well-being of our clients through the application of
				appropriate and proven risk management techniques. Because insurance
				provides certainty in uncertain times, an objective third-party
				evaluation of risk-based needs is integral for every successful
				individual or business concern. Experience, knowledge, independence, and
				a broad base of advisors enable UWAG to offer customized options that
				employ a variety of products, concepts, and carriers.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				At our core, we believe we need to know our clients intimately. We
				desire to know what makes them happy, what motivates them, and what may
				potentially hold them back from achieving financial independence. We
				also remain aware of the changes in our clients' lives to ensure that we
				adjust our recommendations accordingly.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When you choose the Stan Steele Agency, not only do you get the
				expertise of our local team, but you also are partnering with a national
				team of highly qualified advisors within multiple disciplines. This
				means that we can offer you all the benefits of a national wealth
				management firm along with the value, commitment, and passion of a local
				business in your community.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				You are more than a number to us--We exist to serve you!
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Learn more at{' '}
				<a
					href="https://www.uwagllc.com"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					https://www.uwagllc.com (opens in a new tab)
				</a>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Securities and investment advisory services offered solely through
				Ameritas Investment Corp. (AIC). Member FINRA/SIPC. AIC and Stan Steele
				Agency, Inc are not affiliated.
			</p>
		</main>
	)
}
